import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export const DrawerLink = ({ resource, action = 'show', source, label, relative = false, sx = { fontFamily: 'Inter,Arial,sans-serif' }, onClick }) => {
    const prefix = relative ? '' : `/${resource}`;

    return (
        <Link
            to={`${prefix}#${source}?${resource}-${action}`}
            onClick={onClick}
            style={{
                color: 'inherit',
                textDecoration: 'none',
                fontWeight: '400',
                ...sx,
            }}
        >
            {label}
        </Link>
    );
};

DrawerLink.propTypes = {
    resource: PropTypes.string.isRequired,
    action: PropTypes.oneOf(['show', 'edit']),
    source: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    relative: PropTypes.bool,
    sx: PropTypes.object,
    onClick: PropTypes.func,
};
